import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "submit"]

  connect() {
    this.updateSelectAll()
    this.updateSubmitButton()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
    this.updateSubmitButton()
  }

  updateSelectAll() {
    this.selectAllTarget.checked = this.checkboxTargets.every((cb) => cb.checked)
    this.updateSubmitButton()
  }

  updateSubmitButton() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked)
    this.submitTarget.disabled = !anyChecked
    this.submitTarget.classList.toggle("c-button--disabled", !anyChecked)
  }
}
